import { useEffect, useRef, useState } from "react";
import { SlidersHorizontal, ArrowUp, ArrowDown, Eye, EyeOff, RotateCcw, X } from "lucide-react";
import { Btn } from "@/components/ui-kit";

export function DashboardCustomizer({ items, move, toggle, reset }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    if (open) document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <Btn size="sm" onClick={() => setOpen((o) => !o)} data-testid="dashboard-customize-btn">
        <SlidersHorizontal size={14} /> Customize
      </Btn>
      {open && (
        <div className="absolute right-0 mt-2 w-72 bg-white rounded-xl border border-slate-200 shadow-xl z-40 p-3 animate-scale-in" data-testid="dashboard-customize-panel">
          <div className="flex items-center justify-between px-1 pb-2 mb-1 border-b border-slate-100">
            <span className="text-[12.5px] font-bold text-slate-700">Customize layout</span>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-700" data-testid="dashboard-customize-close"><X size={15} /></button>
          </div>
          <div className="space-y-1">
            {items.map((it, idx) => (
              <div key={it.id} className="flex items-center gap-1.5 px-1 py-1.5 rounded-lg hover:bg-slate-50" data-testid={`customize-row-${it.id}`}>
                <button onClick={() => toggle(it.id)} className={`shrink-0 ${it.visible ? "text-teal-600" : "text-slate-300"}`} title={it.visible ? "Hide" : "Show"} data-testid={`customize-toggle-${it.id}`}>
                  {it.visible ? <Eye size={15} /> : <EyeOff size={15} />}
                </button>
                <span className={`flex-1 text-[13px] truncate ${it.visible ? "text-slate-700" : "text-slate-400"}`}>{it.label}</span>
                <button disabled={idx === 0} onClick={() => move(it.id, -1)} className="shrink-0 text-slate-400 hover:text-slate-700 disabled:opacity-30" title="Move up" data-testid={`customize-up-${it.id}`}><ArrowUp size={14} /></button>
                <button disabled={idx === items.length - 1} onClick={() => move(it.id, 1)} className="shrink-0 text-slate-400 hover:text-slate-700 disabled:opacity-30" title="Move down" data-testid={`customize-down-${it.id}`}><ArrowDown size={14} /></button>
              </div>
            ))}
          </div>
          <button onClick={reset} className="mt-2 w-full flex items-center justify-center gap-1.5 text-[12px] font-semibold text-slate-500 hover:text-slate-700 py-1.5" data-testid="dashboard-customize-reset">
            <RotateCcw size={13} /> Reset to default
          </button>
        </div>
      )}
    </div>
  );
}
